import './spinner_loader.css';

export const SpinnerLoader = () => {
    return (
        <span className="spinner_loader"></span>
    );
}